import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
const PDPShopTabsBarPlaceholder = t0 => {
  const $ = _c(2);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isLayoutRevamp) {
    t2 = isLayoutRevamp ? <div className="flex gap-4 w-full h-[61px]"><Placeholder type="rect" loading={true} className="!flex-1 !h-full !m-0" /><Placeholder type="rect" loading={true} className="!flex-1 !h-full !m-0" /></div> : <Placeholder type="rect" loading={true} className="!w-full !h-[58px]" />;
    $[0] = isLayoutRevamp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
PDPShopTabsBarPlaceholder.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
export default PDPShopTabsBarPlaceholder;